<template>
  <div class="dynamic_input">

    <!-- Infotip -->
    <div class="dynamic_input_infotip" v-if="infotext!=undefined">
      <v-btn icon x-small @click.stop="showInfotip">
        <v-icon color="primary">mdi-information-outline</v-icon>
      </v-btn>
      <div ref="dynamic_input_infocard" v-show="infotip==true">
        <p>{{infotext}}</p>
      </div>
    </div>
    
    <!-- File -->
    <v-file-input :label="label" v-if="type == 'file'" @change="processFile">
      <template v-slot:append>
        <v-btn small icon :disabled="value==null" @click="downloadFile">
            <v-icon color="primary">mdi-progress-download</v-icon>
        </v-btn>
        <v-btn small icon :disabled="value==null" @click="$emit('input', null)">
            <v-icon color="error">mdi-close</v-icon>
        </v-btn>
      </template>
    </v-file-input>

    <!-- String -->
    <v-text-field :label="label" type="text" v-if="type == 'string'" :readonly="access == 1" :suffix="showSuffix(access)" v-bind:value="value" @input="$emit('input', $event)" />

    <!-- Number -->
    <v-text-field :label="label" type="number" :readonly="access == 1" :suffix="showSuffix(access)" v-if="type == 'number'" :min="min" :max="max" v-bind:value="value"  @input="$emit('input', Number($event))" />
    
    <!-- Textarea -->
    <v-textarea :label="label" v-if="type == 'textarea'" :suffix="showSuffix(access)" :readonly="access == 1" v-bind:value="value" @input="$emit('input', $event)" />

    <!-- Boolean -->
    <v-select :label="label" v-if="type == 'boolean'" v-bind:value="value" @change="$emit('input', $event)" :items="boolArray" />

    <!-- Enum -->
    <v-select :label="label" v-if="type == 'enum'" v-bind:value="getNumber(value)" @change="$emit('input', $event)" :items="items" :item-text="item_text==null?'text':item_text" :item-value="item_value==null?'value':item_value" />

    <!-- KeyValue -->
    <v-data-table v-if="type == 'keyvalue'" :headers="headers" :items="table_items">

      <template v-slot:top>
        <v-toolbar flat dense class="indigo darken-1 headline" primary-title>
          <v-toolbar-title class="white--text">Headers</v-toolbar-title>
          <v-btn small light @click="headerdialog = true; createHeaderForm();">
            <v-icon color="primary">mdi-plus</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:[`item.key`]="{ item }">
        <v-text-field v-model="item.key" label="Key" placeholder="Key"></v-text-field>
      </template>

      <template v-slot:[`item.value`]="{ item }">
        <v-text-field v-model="item.value" label="Value" placeholder="value" />
      </template>

      <template v-slot:[`item.delete`]="{ item }">
        <v-btn small light @click="deleteHeader(item)">
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
      </template>
    </v-data-table>

    <!-- SQL -->
    <QueryEditor v-bind:value="{query:value}" :template="[]" @input="$emit('input', $event.query)" v-if="type=='sql'" :emit_back="true" /> 
  </div>
</template>

<script>
import MimeTypeCatalog from './MimeTypes.js';
import QueryEditor from '@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue';
export default {
  props: ["value", "type", "label", "options", "items", "max", "min", "access", "item_text", "item_value", 'infotext'],
  components : {
    QueryEditor
  },
  data() {
    return {
      headers: [
        { text: "Key", value: "key", sortable: false, },
        { text: "Value", value: "value", sortable: false, },
        { value: "delete", sortable: false, },
      ],
      boolArray: [
        { text: "False", value: false, },
        { text: "True", value: true, },
      ],
      infotip : false,
      table_items: null,
    };
  },
  methods: {
    getNumber(value){
      if(value == null){ return NaN; }
      return Number(value);
    },
    showInfotip(){
      this.infotip = true;
      document.body.addEventListener('click', this.hideInfotip);
    },
    hideInfotip(){
      document.body.removeEventListener('click', this.hideInfotip);
      this.infotip = false;
    },
    showSuffix(access) {
      switch (access) {
        case 1:
          return "readonly";
        case 2:
          return "mandatory";
      }
    },
    processFile(event) {
      if(event == null){ return; }
      const that = this;
      const reader = new FileReader();
      reader.onload = function () {
        that.$emit("input", reader.result);
      };
      reader.readAsDataURL(event);
    },
    downloadFile(){
      let link = document.createElement('a');
      link.href = this.value;
      const start_index = this.value.indexOf('data:') + 5;
      const length = this.value.indexOf(';base64') - start_index;
      const mime_type = this.value.substr(start_index, length);
      let extension = MimeTypeCatalog.getExtension(mime_type);
      if(extension == null){ extension = 'bin'; }
      link.download = 'Untitled.' + extension;
      link.click();
      link = null;
    },

    createHeaderForm() {
      this.table_items.push({ value: null, key: null });
    },
    deleteHeader(item) {
      let i = this.table_items.findIndex((it) => it == item);
      this.table_items.splice(i, 1);
    },
  },
  mounted() {
    this.table_items = this.value ? this.value : new Array();
  },
};
</script>
<style scoped>
.dynamic_input{
  position: relative;
}
.dynamic_input_infotip{
  position: absolute;
  top:-10px;
  right:0;
  text-align: right;
  width:100%;
  z-index: 2;
}
.dynamic_input_infotip > div{
  position: relative;
  width:100%;
  background-color: white;
  border-radius: 5px;  
  text-align: left;
  margin-top:5px;
  padding: 5px;
  box-shadow: 0px 4px 8px rgba(0,0,0,0.4);
}
.dynamic_input_infotip > div > p{
  margin:0;
  padding:0;
  line-height: 22px;
}
</style>
